<template>
  <div>
    <h5 style="margin-bottom: 1.5rem">{{ formText.title }}</h5>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group" :class="{ error: hasError('company') }">
          <label for="company">{{ formText.company }}</label>
          <input
            id="company"
            v-model="address.company"
            type="text"
            class="form-control"
            maxlength="255"
          />
        </div>
        <div v-if="hasError('company')" class="invalid-feedback">
          <small>Required</small>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group" :class="{ error: hasError('firstName') }">
          <label for="first_name">{{ formText.firstName }}</label>
          <input
            id="first_name"
            v-model="address.firstName"
            type="text"
            class="form-control"
            maxlength="255"
          />
          <div v-if="hasError('firstName')" class="invalid-feedback">
            <small>Required</small>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group" :class="{ error: hasError('lastName') }">
          <label for="last_name">{{ formText.lastName }}</label>
          <input
            id="last_name"
            v-model="address.lastName"
            type="text"
            class="form-control"
            maxlength="255"
          />
          <div v-if="hasError('lastName')" class="invalid-feedback">
            <small>Required</small>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-8">
        <div class="form-group" :class="{ error: hasError('address') }">
          <label for="address_1">{{ formText.address }}</label>
          <input
            id="address_1"
            v-model="address.address"
            type="text"
            class="form-control"
            maxlength="255"
          />
          <div v-if="hasError('address')" class="invalid-feedback">
            <small>Required</small>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div class="form-group" :class="{ error: hasError('address2') }">
          <label for="address_2">{{ formText.address2 }}</label>
          <input
            id="address_2"
            v-model="address.address2"
            type="text"
            class="form-control"
            maxlength="255"
          />
          <div v-if="hasError('address2')" class="invalid-feedback">
            <small>Required</small>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div :class="country === 'US' ? 'col-sm-3' : 'col-sm-6'">
        <div class="form-group" :class="{ error: hasError('city') }">
          <label for="city">{{ formText.city }}</label>
          <input
            id="city"
            v-model="address.city"
            type="text"
            class="form-control"
            maxlength="255"
          />
          <div v-if="hasError('city')" class="invalid-feedback">
            <small>Required</small>
          </div>
        </div>
      </div>
      <div v-if="country === 'US'" class="col-sm-3">
        <div class="form-group" :class="{ error: hasError('county') }">
          <label for="county">{{ formText.county }}</label>
          <input
            id="county"
            v-model="address.county"
            type="text"
            class="form-control"
            maxlength="255"
          />
          <div v-if="hasError('county')" class="invalid-feedback">
            <small>Required</small>
          </div>
        </div>
      </div>
      <div v-else>
        <input id="county" v-model="address.county" type="hidden" value="" />
      </div>
      <div class="col-xs-6 col-sm-3">
        <div class="form-group" :class="{ error: hasError('state') }">
          <label for="state">{{ formText.state }}</label>
          <select
            id="state"
            v-model="address.state"
            name="state"
            class="form-control"
          >
            <option
              v-for="(state, i) in states"
              :key="'state_' + i"
              :name="state.name"
              :value="state.code"
            >
              {{ state.name }}
            </option>
          </select>
          <div v-if="hasError('state')" class="invalid-feedback">
            <small>Required</small>
          </div>
        </div>
      </div>
      <div class="col-xs-6 col-sm-3">
        <div class="form-group" :class="{ error: hasError('zip') }">
          <label for="zip">{{ formText.zip }}</label>
          <input
            id="zip"
            v-model="address.zip"
            type="text"
            class="form-control"
          />
          <div
            v-if="hasError('zip') || hasError('zip-invalid')"
            class="invalid-feedback"
          >
            <small v-if="hasError('zip-invalid')"> Invalid value </small>
            <small v-else> Required </small>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 2rem">
      <div class="col-md-12">
        <small>{{ formText.notice }}</small>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6" style="text-align: left">
        <button
          v-if="cancellable"
          class="btn btn-secondary"
          type="button"
          @click="handleCancel"
        >
          {{ formText.cancel }}
        </button>
      </div>
      <div class="col-md-6" style="text-align: right">
        <div>
          <validate-address
            :address="address"
            :button-text="formText.submit"
            @missing-fields="setMissingFields"
            @validated="handleSubmit()"
          ></validate-address>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import frCA from "../../../../localization/fr-CA/forms/newAddress.json";
import enCA from "../../../../localization/en-CA/forms/newAddress.json";
import enUS from "../../../../localization/en-US/forms/newAddress.json";

export default {
  props: {
    userId: {
      type: Number,
      required: true,
    },
    cancellable: {
      type: Boolean,
      default: false,
    },
    cancellableText: {
      type: String,
      default: "Back",
    },
    submitText: {
      type: String,
      default: "Submit",
    },
    successResponse: {
      type: String,
      required: true,
    },
    errorResponse: {
      type: String,
      required: true,
    },
    country: {
      type: String,
      required: true,
    },
    states: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      address: {
        company: "",
        firstName: "",
        lastName: "",
        address: "",
        address2: "",
        city: "",
        county: "",
        state: "",
        zip: "",
        country: this.country,
        validationType: null,
        validatedAddress: null,
      },
      missingFields: [],
      submitting: false,
    };
  },
  computed: {
    formText() {
      if (this.getNavigatorLanguage() === "fr-CA") return frCA;
      if (this.getNavigatorLanguage() === "en-CA") return enCA;
      return enUS;
    },
    validationPending() {
      return this.address.validationType === null;
    },
    addressToValidate() {
      return {
        firstName: this.address.firstName,
        lastName: this.address.lastName,
        address: this.address.address,
        address2: this.address.address2,
        city: this.address.city,
        county: this.address.county,
        state: this.address.state,
        zip: this.address.zip,
        country: this.address.country,
      };
    },
  },
  methods: {
    setMissingFields(missingFields) {
      this.missingFields = missingFields;
    },

    checkRequiredFields() {
      const missingFields = [
        "firstName",
        "lastName",
        "address",
        "city",
        "state",
        "zip",
      ].filter((field) => !this.address[field]);

      this.setMissingFields(missingFields);

      return missingFields.length === 0;
    },

    hasError(field) {
      return this.missingFields.includes(field);
    },

    handleSubmit() {
      this.checkRequiredFields();

      if (this.missingFields.length > 0) {
        return;
      }

      const payload = {
        company: this.address.company,
        first_name: this.address.firstName,
        last_name: this.address.lastName,
        address: this.address.address,
        address2: this.address.address2,
        city: this.address.city,
        county: this.address.county,
        state: this.address.state,
        zip: this.address.zip,
        country: this.address.country,
        validation_type: this.address.validationType,
        validated_address: this.address.validatedAddress,
      };

      this.submitting = true;

      this.$http
        .post(`/users/${this.userId}/addresses`, payload)
        .then((response) => {
          this.handleSuccess(response.data);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            this.missingFields = Object.keys(e.response.data.errors);
            if (
              this.hasError("zip") &&
              e.response.data.errors.zip.includes("validation.postal_code")
            ) {
              // special handling for the postal code server side validation
              this.missingFields.push("zip-invalid");
            }
          } else {
            this.handleError(e);
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    handleSuccess(payload) {
      this.$emit(this.successResponse, payload);
    },

    handleError(message) {
      this.$emit(this.errorResponse, message);
    },

    handleCancel() {
      this.$emit("handleCancel");
    },

    getNavigatorLanguage() {
      return navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.userLanguage ||
            navigator.language ||
            navigator.browserLanguage ||
            "en";
    },
  },
};
</script>

<style scoped>
.invalid-feedback small {
  color: red;
}
</style>
